import {
  addBtnConfig,
  addOrEditLeanBtnConfig,
  AreaType,
  BtnConfigActionType,
  deleteBtnConfig,
  getLeanDataConfig,
  getPortalBtnList,
  LeanBtnConfigReq,
  LeanDataConfigRes,
  MajorShowBtnConfigListRes,
  StationType,
  StationTypeFormtter,
  updatePortalBtn,
  UpdatePortalBtnReq,
} from '@/api/energyAssetsPortalConfig';
import { InfoCircleOutlined } from '@ant-design/icons';
import {
  Table,
  Form,
  InputNumber,
  Modal,
  PopConfirm,
  Radio,
  Button,
  EllipsisSpan,
  useUpdate,
} from '@maxtropy/components';
import { Col, Row, Space, Spin } from 'antd';
import React, { Key, useEffect, useRef, useState } from 'react';
import EditBtnModalForm, { IFieldForm } from '../EditBtnModalForm';

const columns = [
  {
    title: '序号',
    dataIndex: 'sortNum',
    width: 160,
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '按钮名称',
    dataIndex: 'buttonName',
    width: 160,
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: 'URL',
    dataIndex: 'url',
    width: 160,
    ellipsis: { showTitle: true },
    render: (v: string) => {
      return <EllipsisSpan value={v} />;
    },
  },
  {
    title: '备注',
    dataIndex: 'remark',
    width: 160,
    ellipsis: { showTitle: true },
    render: (v: number) => <EllipsisSpan value={v} />,
  },
];

const LeanEnergyManagementConfig = () => {
  const [form] = Form.useForm();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [topDataLoading, setTopDataLoading] = useState(false);

  const [dataSource, setDataSource] = useState<MajorShowBtnConfigListRes[]>();

  const [updateState, updateFn] = useUpdate();
  const [updateTopState, updateTopFn] = useUpdate();

  const [row, setRow] = useState<MajorShowBtnConfigListRes>();
  const [addBtnTypeModal, setAddBtnTypeModal] = useState<BtnConfigActionType>();

  const [leanDataConfig, setLeanDataConfig] = useState<LeanDataConfigRes>();

  const cFormRef = useRef<IFieldForm>();

  useEffect(() => {
    setLoading(true);
    getPortalBtnList({ type: AreaType.leanEMStation }).then(res => {
      setDataSource(
        res.map((i, index) => {
          return {
            ...i,
            sortNum: index + 1,
          };
        })
      );
      setLoading(false);
    });
  }, [updateState]);

  useEffect(() => {
    setTopDataLoading(true);
    getLeanDataConfig().then(res => {
      setLeanDataConfig(res);
      form.setFieldsValue({
        type: res.type,
        dayEnergyConsumption: res.dayEnergyConsumption,
        dayOutput: res.dayOutput,
        lineTotal: res.lineTotal,
        lineOn: res.lineOn,
      });
      setTopDataLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTopState]);

  // 保存上层表单
  const onFinish = (val: LeanBtnConfigReq) => {
    addOrEditLeanBtnConfig(val).then(_ => {
      updateTopFn();
      setIsEdit(false);
    });
  };

  // 重置
  const init = () => {
    setRow(undefined);
    setAddBtnTypeModal(undefined);
    cFormRef.current?.reset();
  };

  const handleEditBtn = (v: UpdatePortalBtnReq | undefined) => {
    if (v) {
      if (v.id) {
        updatePortalBtn(v).then(_ => {
          init();
          updateFn();
        });
      } else {
        addBtnConfig(v).then(_ => {
          init();
          updateFn();
        });
      }
    } else {
      init();
    }
  };

  const removeMajorArea = (id: Key) => {
    deleteBtnConfig(id).then(_ => {
      updateFn();
    });
  };

  const buildColumns = [
    ...columns,
    {
      title: '操作',
      fixed: 'right' as 'right',
      width: 183,
      render: (_: undefined, record: MajorShowBtnConfigListRes) => (
        <>
          <Space size={16}>
            <PopConfirm
              title={'确定删除？'}
              onConfirm={() => removeMajorArea(record.id)}
              okText="确定"
              cancelText="取消"
            >
              <Button type="link" style={{ padding: 0 }}>
                删除
              </Button>
            </PopConfirm>
            <Button
              type="link"
              style={{ padding: 0 }}
              onClick={() => {
                setRow(record);
                setAddBtnTypeModal(BtnConfigActionType.ADDLEANEM);
              }}
            >
              编辑
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const addLeanBtn = () => {
    if (dataSource && dataSource?.length >= 4) {
      Modal.error({ title: <span style={{ color: 'var(--mx-text-base-color)' }}>最多新建4个按钮！</span> });
    } else {
      setRow(undefined);
      setAddBtnTypeModal(BtnConfigActionType.ADDLEANEM);
    }
  };

  const onCancel = () => {
    form.setFieldsValue({
      type: leanDataConfig?.type,
      dayEnergyConsumption: leanDataConfig?.dayEnergyConsumption,
      dayOutput: leanDataConfig?.dayOutput,
      lineOn: leanDataConfig?.lineOn,
      lineTotal: leanDataConfig?.lineTotal,
    });
    setIsEdit(false);
  };

  return (
    <div>
      {isEdit ? (
        <Space size={8}>
          <Button
            key="saveLean"
            type="primary"
            onClick={() => {
              form.submit();
            }}
          >
            保存
          </Button>
          <Button
            key="cancelLean"
            onClick={() => {
              onCancel();
            }}
          >
            取消
          </Button>
        </Space>
      ) : (
        <Button
          key="editLean"
          type="primary"
          onClick={() => {
            setIsEdit(true);
          }}
        >
          编辑
        </Button>
      )}
      <Spin spinning={topDataLoading}>
        <Form
          style={{ marginTop: 12 }}
          form={form}
          labelAlign="left"
          onFinish={(val: LeanBtnConfigReq) => onFinish(val)}
        >
          <Row gutter={8}>
            <Col span={6}>
              <Form.Item name="type" label="站点统计数据来源" rules={[{ required: true, message: '请选择' }]}>
                <Radio.Group style={{ width: '100%' }} disabled={!isEdit}>
                  <Radio value={StationType.PlatformArea}>{StationTypeFormtter[StationType.PlatformArea]}</Radio>
                  <Radio value={StationType.ConfigArea}>{StationTypeFormtter[StationType.ConfigArea]}</Radio>
                  <Radio value={StationType.Disable}>{StationTypeFormtter[StationType.Disable]}</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item noStyle dependencies={['type']}>
                {({ getFieldValue }) =>
                  getFieldValue('type') === StationType.ConfigArea && (
                    <>
                      <Form.Item
                        name="dayEnergyConsumption"
                        label="日综合能耗"
                        rules={[{ required: true, message: '请输入' }]}
                      >
                        <InputNumber
                          disabled={!isEdit}
                          style={{ width: '80%' }}
                          addonAfter="kgce"
                          min={0}
                          max={99999999}
                          placeholder="请输入"
                        />
                      </Form.Item>
                    </>
                  )
                }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item noStyle dependencies={['type']}>
                {({ getFieldValue }) =>
                  getFieldValue('type') === StationType.ConfigArea && (
                    <>
                      <Form.Item name="dayOutput" label="日产量" rules={[{ required: true, message: '请输入' }]}>
                        <InputNumber
                          disabled={!isEdit}
                          style={{ width: '80%' }}
                          min={0}
                          max={99999999}
                          placeholder="请输入"
                        />
                      </Form.Item>
                    </>
                  )
                }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item noStyle dependencies={['type']}>
                {({ getFieldValue }) =>
                  getFieldValue('type') === StationType.ConfigArea && (
                    <>
                      <Form.Item style={{ marginBottom: 0 }}>
                        <Form.Item
                          name="lineOn"
                          label="开线数量"
                          rules={[{ required: true, message: '请输入' }]}
                          style={{ display: 'inline-block', width: 'calc(55% - 6px)', marginRight: 2 }}
                        >
                          <InputNumber
                            disabled={!isEdit}
                            style={{ width: '100%' }}
                            min={0}
                            max={99999999}
                            placeholder="开线数"
                          />
                        </Form.Item>
                        <Form.Item
                          name="lineTotal"
                          rules={[{ required: true, message: '请输入' }]}
                          style={{ display: 'inline-block', width: 'calc(45% - 6px)' }}
                        >
                          <InputNumber
                            disabled={!isEdit}
                            style={{ width: '100%' }}
                            addonAfter="个"
                            min={0}
                            max={99999999}
                            placeholder="总数"
                          />
                        </Form.Item>
                      </Form.Item>
                    </>
                  )
                }
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
      <div>
        <div
          style={{
            marginBottom: 10,
          }}
        >
          <Button type="primary" onClick={() => addLeanBtn()}>
            新建
          </Button>
          <span style={{ marginLeft: 12 }}>
            <InfoCircleOutlined style={{ color: 'var(--mx-warning-color)' }} />
            <span style={{ marginLeft: 4, color: 'var(--mx-text-desc-color)' }}>最多新建4个按钮</span>
          </span>
        </div>
        <Table
          scroll={{ y: 450 }}
          rowKey="id"
          loading={loading}
          className="tableScroll"
          columns={[...buildColumns]}
          dataSource={dataSource}
          pagination={false}
        />
        <EditBtnModalForm cref={cFormRef} row={row} addBtnTypeModal={addBtnTypeModal} handleEditBtn={handleEditBtn} />
      </div>
    </div>
  );
};

export default LeanEnergyManagementConfig;
